// extracted by mini-css-extract-plugin
export default {"title":"Trips_title__EJCYi","content":"Trips_content__4zW5l","wrapper":"Trips_wrapper__ReHcA","hr":"Trips_hr__xQhI5","image":"Trips_image__ymtbF","contents":"Trips_contents__YQn9M"};